module.exports = __webpack_public_path__ + "../resources/img/mon_graph_img6.86de0518.png";